import {FETCHING_DATA, DATA_FETCHED, ERROR_FETCHING, CLEAR_ERROR} from '../actionTypes';
import * as constants from '../../common/constants';

const suppressErrorList = [constants.GENERIC_ERROR_MESSAGE, "Out of memory", "Network request failed", "Failed to fetch", "NetworkError when attempting to fetch resource.", "Communication Error. Please Try again", constants.UNAUTHORIZED_ACTION, constants.NO_COOKIE_CREATE, constants.NO_COOKIE_LOGIN, constants.CIM_NOT_ENABLED, "failed during invocation of WebStoreService", "The Details you provided failed authentication", "Forbidden"];
const reloadingWindowErrors = [constants.UNAUTHORIZED_ACTION, constants.ORDER_KEY_CHANGED, constants.PICKUP_SITE_KEY_CHANGED, constants.GEOCODE_ERROR,
    constants.SUBSCRIPTION_EXISTS_ERROR_MESSAGE, constants.GOOGLE_UNDEFINED_ERROR_MESSAGE, constants.OPERATION_ABORTED_ERROR_MESSAGE, "Can't delete order", constants.OLD_VERSION_MESSAGE];

export function isFetching(state, type){
    if (!state.fetching.isFetching)
        return false;
    if (state.fetching.fetchingType === constants.FetchingTypes.LOG_OUT)
        return true;
    if (type)
        return state.fetching.fetchingType === type;
    return true;
}
export function fetchingData(fetchingType){
    return {
        type: FETCHING_DATA,
        fetchingType: fetchingType
    }
}

export function dataFetched(fetchingType){
    return {
        type: DATA_FETCHED,
        fetchingType
    }
}

export function errorFetching(error, retryAction, suppressError){
    if (suppressErrorList.includes(error) || suppressErrorList.includes(error.message) || error.suppress)
        suppressError = true;
    if (reloadingWindowErrors.includes(error) || reloadingWindowErrors.includes(error.message)) {
        suppressError = true;
        retryAction = {action:reloadWindow, args:[], label:"Reload"};
    }
    if (!suppressError) {
        console.error(error);
        if (typeof Raven !== 'undefined') Raven.captureException(error);
    }
    return {
        type: ERROR_FETCHING,
        error,
        retryAction
    }
}

export function retryFetching(){
    return function (dispatch, getState){
        const retryAction = getState().fetching.error.retryAction;
        if (retryAction)
            dispatch(retryAction.action.apply(null, retryAction.args));
    }
}

export function clearError(){
    return {
        type: CLEAR_ERROR
    }
}

function reloadWindow(){
    return function() {
        window.location.reload(true);
    }
}



// WEBPACK FOOTER //
// ./src/actions/common/fetchingActions.js